<template>
    <!--Google Map Start-->
    <section class="google-map google-map-two">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26672.083988611925!2d-71.4065348!3d-33.318540999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x62b602e47ce9bff1%3A0xa8577bb41167c844!2sIngenier%C3%ADa%20El%C3%A9ctrica%20e%20Hidr%C3%A1ulica%20SpA!5e0!3m2!1ses!2sve!4v1672689599805!5m2!1ses!2sve"
                class="google-map__one" allowfullscreen></iframe>
                
        </section>
        <!--Google Map End-->

</template>

<script>
</script>